export default {
  title: 'Gateway de pagamento',
  description:
    'Os seus próprios gateways de pagamento para encomendas online. O valor total da encomenda é liquidado na sua conta de gateway; você acerta contas com os seus restaurantes.',
  toasts: {
    load_error: 'Falha ao carregar a configuração do gateway',
  },
  not_enabled: {
    title: 'O Spreedly ainda não está ativado para a sua conta',
    description:
      'Os gateways de pagamento locais são ativados pela FoodAmigos. Contacte o seu representante FoodAmigos para começar.',
  },
  processor_mode: {
    title: 'Quem processa os pagamentos?',
    description:
      'Isto é definido uma vez para todos os seus restaurantes. Pode alterar mais tarde nas Definições do parceiro, desde que nenhum restaurante esteja ativo.',
    save: 'Guardar',
    options: {
      platform: {
        title: 'A FoodAmigos processa os pagamentos',
        badge: 'Recomendado',
        description:
          'Tratamos da conta de pagamento, verificação e pagamentos. Cada restaurante adiciona os seus dados comerciais e completa uma verificação rápida com a Adyen.',
        methods: 'Aceites: {{methods}}',
      },
      provider: {
        title: 'Uso o meu próprio fornecedor',
        description:
          'Ligue um fornecedor de pagamentos que já utiliza. Os pagamentos, taxas e verificação ficam com eles.',
      },
    },
    payment_methods: {
      card: 'Cartão',
      apple_pay: 'Apple Pay',
      google_pay: 'Google Pay',
      pay_by_bank: 'Pagar pelo banco',
      giropay: 'giropay',
      sepa_debit: 'SEPA',
    },
    locked: {
      platform: 'A FoodAmigos processa os pagamentos de todos os seus restaurantes.',
      provider: 'Os seus restaurantes recebem pagamentos através dos seus próprios fornecedores.',
    },
    confirm_choice: {
      title: 'Definir pagamentos como “{{mode}}”?',
      description:
        'Isto aplica-se a todos os restaurantes que gere. Pode alterar mais tarde nas Definições do parceiro, mas apenas enquanto nenhum restaurante estiver ativo.',
      confirm: 'Guardar e continuar',
    },
    switch: {
      link: 'Alterar como os pagamentos são processados',
      confirm: {
        confirm: 'Mudar',
        provider: {
          title: 'Mudar para o seu próprio fornecedor?',
          description: 'Os restaurantes que usam pagamentos FoodAmigos voltarão a Não configurado.',
        },
        platform: {
          title: 'Mudar para pagamentos FoodAmigos?',
          description: 'Os restaurantes que usam os seus próprios fornecedores voltarão a Não configurado.',
        },
      },
      unavailable: {
        title: 'Os pagamentos FoodAmigos ainda não estão disponíveis',
        description: 'Os pagamentos FoodAmigos ainda não estão disponíveis no seu país.',
        confirm: 'OK',
      },
      blocked: {
        title: 'Contacte a FoodAmigos para alterar isto',
        description_one:
          '{{count}} restaurante está a receber pagamentos ao vivo. A mudança significa que terá de fazer novo onboarding com o novo fornecedor. A nossa equipa irá planear isso consigo.',
        description_other:
          '{{count}} restaurantes estão a receber pagamentos ao vivo. Mudar significaria que teriam de reintegrar com o novo fornecedor. A nossa equipa irá planear isto consigo.',
        confirm: 'Enviar email à FoodAmigos',
        subject_one: 'Alterar a forma como os pagamentos são processados ({{count}} restaurante ativo)',
        subject_other: 'Alterar como os pagamentos são processados ({{count}} restaurantes ao vivo)',
      },
    },
    toasts: {
      load_error: 'Falha ao carregar a configuração de pagamentos',
      save_error: 'Falha ao guardar a configuração de pagamentos',
      chosen: 'Processamento de pagamentos guardado',
      switched: 'Processamento de pagamentos alterado',
    },
  },
  gateways: {
    title: 'Fornecedores ligados',
    empty: 'Associe o fornecedor de pagamentos que já utiliza. Os seus restaurantes serão integrados através dele.',
    connect_another: 'Ligar um fornecedor',
    support_hint:
      'Assim que um restaurante começar a receber pagamentos em produção, a alteração do fornecedor é planeada connosco — escreva para {{email}}.',
    kinds: {
      stripe_connect: 'Stripe Connect',
      spreedly: 'Gateway de pagamento',
      platform_adyen: 'Pagamentos FoodAmigos',
    },
    statuses: {
      connected: 'Ligado',
      disconnected: 'Desligado',
      needs_attention: 'Requer atenção',
    },
    issue: {
      connect_not_enabled: {
        title: 'O Stripe Connect não está ativado na conta associada a {{name}}',
        description:
          'O Stripe não pode criar contas para os seus restaurantes até que o Connect seja ativado. Ative-o no seu Dashboard do Stripe e volte a verificar aqui.',
      },
      account_restricted: {
        title: 'O Stripe está a bloquear novas contas em {{name}}',
        description:
          'O Stripe restringiu temporariamente a sua conta de criar contas ligadas. Inicie sessão no seu Dashboard do Stripe, confirme que pretendia criar estas contas e volte a verificar aqui.',
      },
      loss_liability_unaccepted: {
        title: 'A Stripe precisa que {{name}} aceite primeiro a responsabilidade por perdas',
        description:
          'A sua plataforma Stripe ainda não aceitou a responsabilidade por saldos negativos nas contas dos seus restaurantes, pelo que a Stripe não as criará. No seu Stripe Dashboard, abra Definições → Connect → Perfil da plataforma e conclua a confirmação de responsabilidade por perdas; depois, verifique novamente aqui. Pode ignorar a nota da Stripe sobre Accounts v2 abaixo.',
      },
      account_creation_refused: {
        title: 'O Stripe recusou criar uma conta de restaurante em {{name}}',
        description: 'Consulte a mensagem abaixo no seu Dashboard do Stripe e volte a verificar aqui.',
      },
      key_invalid: {
        title: 'O Stripe já não aceita a chave que ligou para {{name}}',
        description:
          'A chave foi renovada, revogada ou expirou. Crie uma nova chave no seu Stripe Dashboard e substitua-a aqui.',
      },
      key_access_limited: {
        title: 'A Stripe limitou a chave que ligou para {{name}}',
        description:
          'Uma chave limitada não pode criar transferências nem pagamentos aos seus restaurantes. No Stripe Dashboard, abra Developers → API keys e restaure o acesso total da chave e, de seguida, volte a verificar aqui — ou renove a chave e substitua-a aqui.',
      },
      provider_said: 'O que o Stripe disse: «{{message}}»',
      hint: 'Até isto ser resolvido, os restaurantes associados a este fornecedor não podem começar a receber pagamentos online.',
      open_stripe: 'Abrir Dashboard do Stripe',
      check_again: 'Verificar novamente',
      replace_key: 'Substituir chave',
      cleared: 'O Stripe voltou a aceitar os seus restaurantes',
      still_blocked: 'O Stripe continua a recusar — veja o que disse acima',
    },
    refused: {
      provider_said: 'O que {{name}} disse: “{{message}}”',
      reference: 'Referência:',
      contact_support: 'Enviar e-mail ao suporte',
      support_subject: 'Ligação ao fornecedor de pagamento recusada: {{name}} (ref {{reference}})',
      account_in_test_mode: {
        action: 'Desative o Modo de Teste no Authorize.Net, em {{path}}, e tente novamente.',
        open: 'Abrir Authorize.Net',
      },
      processor_not_configured: {
        action:
          'Contacte o seu prestador de serviços de pagamento, a empresa que abriu a sua conta Authorize.Net, e peça-lhe para concluir a configuração com o processador de pagamentos. Novas chaves não resolverão isto. Depois tente novamente.',
        action_card_connect:
          'Peça ao suporte da CardConnect para ativar autorizações sem cartão presente (e-commerce) neste ID de comerciante. Novas credenciais da API não vão alterar isto. Depois, tente novamente.',
      },
    },
    table: {
      primary_tag: 'Predefinição',
      live_count_one: '{{count}} a receber pagamentos',
      live_count_other: '{{count}} a receber pagamentos',
      attention_count_one: '{{count}} precisa de atenção',
      attention_count_other: '{{count}} precisam de atenção',
      columns: {
        connection: 'Fornecedor',
        status: 'Estado',
        restaurants: 'Restaurantes',
        methods: 'Métodos locais',
      },
      methods_count: '{{enabled}} de {{capable}} ativos',
    },
    picker: {
      recommended: 'Recomendado',
      connect: 'Ligar',
      stripe_connect: {
        title: 'Stripe Connect',
        description:
          'Utilize a sua própria conta Stripe. Cada restaurante conclui o processo de integração da própria Stripe; os pagamentos e as taxas ficam a cargo da Stripe.',
        already_connected: 'Já ligado. Use Editar credenciais na lista para substituir a chave.',
        already_connected_short: 'Já ligado.',
      },
      stripe_direct: {
        title: 'Stripe (direto)',
        description: 'Cobre todos os restaurantes através de uma única conta Stripe sua.',
        unavailable: 'Ainda não disponível na sua região.',
      },
      paypal: {
        direct: 'Ofereça o PayPal a partir da sua própria conta PayPal Business.',
        braintree: 'Aceite cartões, PayPal e Venmo através da sua conta Braintree.',
      },
      other: {
        title: 'Outros fornecedores',
        search: 'Pesquisar fornecedores',
        loading: 'A carregar fornecedores…',
        no_match: 'Nenhum fornecedor chamado «{{query}}».',
        none_available: 'Ainda não há outros fornecedores disponíveis na sua região.',
        load_error: 'Não foi possível carregar a lista de fornecedores.',
        retry: 'Tentar novamente',
        pinned_match: 'Esse fornecedor está fixado acima.',
      },
      not_listed: {
        action: 'O meu fornecedor não está na lista',
        subject: 'Pedido de fornecedor de pagamentos: {{query}}',
      },
      use_foodamigos: {
        no_account: 'Não tenho conta em nenhum destes',
        switch: 'Mudar para os pagamentos FoodAmigos',
      },
    },
    orchestrated: {
      title: 'Ligar {{name}}',
      replace_title: 'Substituir as credenciais de {{name}}',
      intro: 'Introduza as credenciais da sua conta {{name}}. Verificamo-las junto de {{name}} antes de guardar.',
      auth_mode: 'Como inicia sessão neste fornecedor',
      checking: 'A verificar com {{name}}…',
      paypal_direct: {
        intro:
          'Cole o ID de Cliente e o Segredo da aplicação REST do PayPal através da qual os seus restaurantes devem aceitar o PayPal. Verificamos com o PayPal antes de guardar seja o que for.',
        client_id: 'ID de Cliente',
        secret: 'Segredo',
        hint: 'Painel de Programadores do PayPal → Apps & Credentials, no separador Live. Utilize uma aplicação REST da sua conta empresarial.',
        hint_sandbox:
          'PayPal Developer Dashboard → Apps & Credentials, no separador Sandbox: este ambiente só aceita apps de sandbox.',
      },
      braintree: {
        intro:
          'Introduza as chaves de API da sua conta Braintree. O PayPal e o Venmo funcionam assim que forem associados no seu Painel de Controlo Braintree — depois pode ativá-los por ligação.',
      },
      authorize_net: {
        intro:
          'Introduza o ID de Login da API e a Chave de Transação da sua conta Authorize.Net. Verificamo-los com uma pequena autorização de teste: o registo de transações da Authorize.Net mostra-a como 1,00 $ recusado, sem movimentação de dinheiro. A conta deve estar em Modo Live, pois em Modo de Teste a Authorize.Net recusa todos os pagamentos reais.',
        hint: 'Pode encontrar ambos na Interface do Comerciante do Authorize.Net, em {{path}}.',
      },
      card_connect: {
        intro:
          'Introduza o ID de comerciante, o nome de utilizador e a palavra-passe da sua conta CardConnect (CardPointe) em produção. Verificamo-las com uma autorização de 1,00 que anulamos de imediato: o registo de transações do CardPointe mostra-a como uma transação de 1,00 recusada ou anulada, e não é movimentado qualquer dinheiro.',
      },
      stripe_direct: {
        intro:
          'Cole a chave secreta da conta Stripe através da qual cada restaurante deve cobrar. Configuramos o webhook que a Stripe necessita por si.',
        secret_key: 'Chave secreta da Stripe',
        hint: 'Stripe → Developers → API keys. Começa por sk_. Não é necessária a chave publicável.',
        prefix_error: 'As chaves secretas da Stripe começam por sk_.',
      },
      connected: {
        title: '{{name}} está ligado.',
        description:
          'Usaremos estas credenciais para todos os seus restaurantes. Cada restaurante continua a adicionar os seus dados comerciais.',
      },
      errors: {
        generic: 'Não foi possível ligar {{name}}',
      },
    },
    stripe: {
      title: 'Ligar Stripe Connect',
      rotate_title: 'Substituir a sua chave Stripe Connect',
      rotate_intro:
        'Cole uma nova chave secreta e uma chave publicável da mesma conta Stripe. Os seus restaurantes continuam ligados.',
      intro: 'Cole a chave secreta e a chave publicável da sua conta Stripe. Ambas estão em Developers → API keys.',
      verify_and_connect: 'Verificar e ligar',
      checking: 'A verificar com a Stripe…',
      secret_key: {
        label: 'Chave secreta',
        hint: 'Stripe → Developers → API keys. Começa com sk_.',
        prefix_error: 'As chaves secretas começam com sk_. Isto parece ser um tipo de chave diferente.',
      },
      restricted_key: {
        label: 'Chave de API restrita',
        hint: 'Stripe → Developers → API keys → Create restricted key. Começa por rk_. Configure-a conforme descrito acima.',
        prefix_error: 'As chaves restritas começam por rk_. Esta parece ser um tipo de chave diferente.',
      },
      use_restricted_key: 'Usar uma chave restrita em alternativa',
      use_secret_key: 'Usar a chave secreta em alternativa',
      publishable_key: {
        label: 'Chave publicável',
        hint: 'Na mesma página da Stripe. Começa por pk_. As suas lojas online precisam dela para aceitar cartões.',
        prefix_error: 'As chaves publicáveis começam por pk_.',
        mode_mismatch: 'Uma das chaves é de produção e a outra é de teste. Ambas devem ser do mesmo modo Stripe.',
      },
      name: {
        label: 'Nome desta ligação',
        hint: 'Opcional. Mostrado em todos os locais onde este fornecedor aparece listado.',
        placeholder: 'Stripe Connect',
      },
      permissions: {
        title: 'Como criar esta chave',
        start_blank:
          'Quando o Stripe lhe perguntar como vai utilizar a chave, escolha “{{option}}”. Começa com todas as permissões definidas como {{none}}.',
        intro:
          'Depois, defina o interruptor em cada uma destas linhas de secção. Define todas as permissões dessa secção, por isso não é necessário percorrê-las uma a uma.',
        rows_checked: 'Verificamos: {{rows}}',
        secret_key_hint: 'Deixe todas as outras secções em {{none}}. Uma chave secreta não precisa de nenhuma destas.',
        open_stripe: 'Abrir as suas chaves de API do Stripe',
      },
      login_setting: {
        title: 'Desative o início de sessão da Stripe para os seus restaurantes',
        description:
          'No seu Stripe Dashboard, abra Definições → Connect → Pagamentos → Contas externas e desative «{{setting}}». Enquanto estiver ativa, a Stripe obriga cada restaurante a criar um início de sessão Stripe com um número de telefone durante a configuração inicial e pede um código SMS em cada visita posterior, pelo que quem não tiver esse telemóvel não consegue continuar.',
        bank_details:
          'Não se perde nada: os restaurantes introduzem os seus dados bancários no nosso próprio formulário.',
        open_stripe: 'Abrir esta definição da Stripe',
      },
      errors: {
        generic: 'Não foi possível contactar a Stripe',
      },
    },
    default_choice: {
      label: 'Usar como predefinição para os restaurantes',
      hint: 'Os novos restaurantes e os restaurantes que ainda não têm fornecedor são associados automaticamente a este. Deixe desmarcado para escolher você mesmo um fornecedor para cada restaurante.',
    },
    manage: {
      payment_methods: 'Métodos de pagamento',
      edit_credentials: 'Editar credenciais',
      edit_credentials_unavailable: 'Editar credenciais (este fornecedor não está disponível de momento)',
      set_primary: 'Definir como predefinição para novos restaurantes',
      clear_primary: 'Deixar de usar como predefinido para novos restaurantes',
      rename: {
        action: 'Renomear ligação',
        title: 'Renomear esta ligação',
        confirm: 'Guardar',
      },
      disconnect: {
        action: 'Desligar',
        title: 'Desligar {{name}}?',
        confirm: 'Desligar',
        warning_one: '{{count}} restaurante está associado a este fornecedor e voltará ao estado Não configurado.',
        warning_other:
          '{{count}} restaurantes estão associados a este fornecedor e voltarão ao estado Não configurado.',
        live: {
          title_one: 'Os pagamentos online param para {{count}} restaurante ativo',
          title_other: 'Os pagamentos online param para {{count}} restaurantes ativos',
          description:
            'Assim que desligar, os clientes deixam de poder pagar online. Cada restaurante volta a Não configurado até o associar a outro fornecedor.',
          refunds:
            'As encomendas já pagas através deste fornecedor deixam de poder ser reembolsadas a partir do FoodAmigos.',
          pause_one: 'Suspender os pagamentos online deste restaurante',
          pause_other: 'Suspender os pagamentos online destes {{count}} restaurantes',
          confirm: 'Desligar e pausar pagamentos',
        },
      },
      remove: {
        action: 'Remover da lista',
        title: 'Remover {{name}}?',
        description: 'Já está desligado e nenhum restaurante o utiliza. Deixará de aparecer nesta lista.',
        confirm: 'Remover',
      },
    },
    payment_methods: {
      title: 'Métodos de pagamento para {{name}}',
      description:
        'Escolha os métodos locais que os seus restaurantes oferecem através deste fornecedor. Cada um aparece apenas onde a moeda do restaurante corresponde.',
      save: 'Guardar',
      publishable_key: {
        label: 'Chave publicável do Stripe',
        hint: 'O Stripe precisa dela para mostrar o formulário de pagamento. Encontre-a no seu Painel Stripe em Developers → API keys.',
        invalid: 'Uma chave publicável aqui começa com {{prefix}}.',
        clear_to_save:
          'Pertence ao outro modo do Stripe. Limpe-o para guardar com todos os métodos locais desativados.',
      },
      on_other_connection: 'já ativado para {{connection}}',
      other_currency: 'não disponível em {{currency}}',
      delivery_only: '{{name}} (apenas para encomendas de entrega — é necessária a morada do cliente)',
      invite_only:
        '{{name}} (a Stripe disponibiliza-o apenas por convite — solicite acesso no seu painel Stripe primeiro, caso contrário a Stripe recusa todos os pagamentos)',
      also_enable: {
        stripe: 'Ative os mesmos métodos no seu Painel Stripe em Settings → Payment methods, ou o Stripe recusa-os.',
        provider: 'O seu contrato com este fornecedor tem de incluir os métodos que ativar aqui.',
        braintree:
          'Associe primeiro o PayPal e o Venmo no seu Painel de Controlo Braintree em Settings → Processing, ou o Braintree recusa-os. O Venmo é para restaurantes dos EUA que cobram em dólares.',
        paypal_direct:
          'Os pagamentos do PayPal são recebidos nesta conta PayPal Business. Para o Venmo, ligue o Braintree.',
      },
    },
    actions: {
      cancel: 'Cancelar',
    },
    toasts: {
      load_error: 'Não foi possível carregar os seus fornecedores ligados',
      credentials_replaced: 'Credenciais substituídas',
      save_error: 'Não foi possível guardar',
      connected: 'Stripe Connect está ligado',
      renamed: 'Ligação renomeada',
      primary_set: 'Fornecedor predefinido atualizado',
      primary_cleared:
        'Fornecedor predefinido removido. Os novos restaurantes não ficam associados a nenhum fornecedor até escolher um.',
      disconnected: 'Fornecedor desligado',
      removed: 'Fornecedor removido',
      payment_methods_saved: 'Métodos de pagamento guardados',
    },
  },
  restaurants: {
    title: 'Restaurantes',
    description: 'Ponto de situação de cada restaurante na aceitação de pagamentos online.',
    search: 'Pesquisar restaurantes',
    filters: {
      all: 'Todos ({{count}})',
      needs_attention: 'Precisa de atenção ({{count}})',
    },
    empty: 'Ainda não há restaurantes.',
    empty_attention: 'Nada precisa da sua atenção.',
    columns: {
      restaurant: 'Restaurante',
      provider: 'Fornecedor',
      status: 'Estado',
      action: 'Ação',
    },
    no_provider: '—',
    foodamigos_payments: 'Pagamentos FoodAmigos',
    groups: {
      not_set_up: 'Não configurado',
      business_details_missing: 'Faltam dados da empresa',
      hosted_not_finished: 'Formulário do {{provider}} não concluído',
      hosted_not_finished_generic: 'Formulário do fornecedor não concluído',
      waiting_for_provider: 'A aguardar o fornecedor',
      action_needed: 'Ação necessária',
      payments_live: 'Pagamentos ativos',
      online_payments_off: 'Pagamentos online desativados',
      waiting_for_partner: 'A aguardar por si',
    },
    link_expired: 'Link expirado',
    actions: {
      set_up: 'Configurar',
      change: 'Alterar',
      unlink: 'Desvincular',
      remind: 'Lembrar proprietário',
      reminded: 'Lembrado · novamente {{time}}',
    },
    assign: {
      title: 'Que fornecedor deve {{name}} usar?',
      label: 'Fornecedor',
      confirm: 'Guardar',
      cancel: 'Cancelar',
      primary: 'Predefinição',
      none: 'Ligue primeiro um fornecedor.',
    },
    unlink: {
      title: 'Desvincular {{name}} de {{provider}}?',
      title_generic: 'Desvincular {{name}} do respetivo fornecedor?',
      description:
        'O restaurante volta a Não configurado, para que possa escolher o fornecedor certo para ele. O fornecedor continua ligado aos seus outros restaurantes.',
      confirm: 'Desvincular',
    },
    pause: {
      title: 'Os pagamentos online ficam em pausa para {{name}}',
      description:
        'Os seus clientes deixam de poder pagar online até o restaurante ser novamente configurado e verificado com um fornecedor.',
      refunds:
        'As encomendas já pagas através do fornecedor atual deixam de poder ser reembolsadas a partir do FoodAmigos.',
      confirm: 'Suspender os pagamentos online deste restaurante',
    },
    toasts: {
      load_error: 'Falha ao carregar os seus restaurantes',
      assigned: 'Fornecedor guardado',
      assign_error: 'Falha ao guardar o fornecedor',
      unlinked: 'Restaurante desvinculado',
      unlink_error: 'Não foi possível desvincular o restaurante',
      reminded: 'Lembrete enviado ao proprietário',
      remind_error: 'Falha ao enviar o lembrete',
      cooling_down: 'O proprietário já foi lembrado hoje',
    },
  },
  footer: {
    text: 'A sua taxa de serviço FoodAmigos é-lhe faturada independentemente do fornecedor que o restaurante utilizar.',
    link: 'Ver Faturação',
  },
};
